import tinysort from "tinysort";
import "jquery-ui/ui/widgets/autocomplete";

window.deco.listOfPoints = [];
const UKR_ALPH = "абвгґдеєжзиіїйклмнопрстуфхцчшщьюя";

$(".outlets__switch-btn").click(function() {
    const pageToOpen = $(this).data("toggle-page");
    $(".page-to-open")
        .fadeOut(300)
        .promise()
        .done(function() {
            $(".page-to-open[data-page=" + pageToOpen + "]").fadeIn(300);
        });
    $(".outlets__switch-btn").removeClass("active");
    $(this).addClass("active");
    if (pageToOpen === "list") {
        $("#autocomplete").mapcomplete("disable");
        // $(".outlets__search-input").val("");
        // $(".outlets__list-item li").show();
        // $(".outlets__list-item").show();
        // $(".hiddenblock[data-block]").slideUp();
        // $(".icon-plus-css").removeClass("opened");
        // $(".open_hiddenblock").removeClass("opened");
        // $(".outlets__list-item:first-child").find(".icon-plus-css").addClass("opened");
        // $(".outlets__list-item:first-child").find(".open_hiddenblock").addClass("opened");
        // $(".outlets__list-item:first-child").find(".hiddenblock").slideDown();
        // $(".outlets__list-item:first-child").find("li:first-child button").addClass("active");
        // const tempId = $(".outlets__list-item:first-child").find("li:first-child button").data("locality_id");
        // $(".outlets__list-right[data-locality_id=" + tempId + "]").fadeIn(200);
    } else {
        $("#autocomplete").mapcomplete("enable");
    }
});

$(".outlets__clear-button").click(function(e) {
    e.preventDefault();
    $(".outlets__search-input").val("");
    $(".outlets__search-input").focus();
    $(".outlets__list-item li").show();
    $(".outlets__list-item").show();
    $(".hiddenblock[data-block]").slideUp();
    $(".icon-plus-css").removeClass("opened");
    $(".open_hiddenblock").removeClass("opened");
    myMap.setCenter({ lat: 50.4438233, lng: 30.4657254 });
    myMap.setZoom(6);
    $(document).trigger("js-select-brands-changed");
    // window.deco.map.setView([50.4438233, 30.4657254], 11);
});

$(".outlets__search-form").on("submit", function(e) {
    e.preventDefault();
});

$(".outlets__list-item-btn").click(function() {
    if ($(this).hasClass("opened")) {
        $(this)
            .find(".icon-plus-css")
            .removeClass("opened");
    } else {
        $(this)
            .find(".icon-plus-css")
            .addClass("opened");
    }
});

$(".outlets__list-item-hiddenblock button").click(function() {
    const locality_id = $(this).data("locality_id");
    $(".outlets__list-item-hiddenblock button").removeClass("active");
    $(this).addClass("active");
    $(".outlets__list-right")
        .fadeOut(200)
        .promise()
        .done(function() {
            $(
                ".outlets__list-right[data-locality_id=" + locality_id + "]"
            ).fadeIn(200);
            // $(document).trigger("js-select-brands-changed");
            const offsetY = $(
                ".outlets__list-right[data-locality_id=" + locality_id + "]"
            ).offset().top;
            $("html, body").animate(
                {
                    scrollTop: offsetY
                },
                1000
            );
        });
});

$(document).ready(function() {
    $(".outlets__list-item").each(function() {
        const numberOfItems = $(this).find("li").length;
        $(this).attr("data-number-of-items", numberOfItems);
    });
});

let filter_address_list = input => {
    const val = input.val();
    let firstPhrase = val.replace(/,.*/, "");
    const regExpVal = new RegExp(firstPhrase, "i");
    $(".open_hiddenblock").addClass("opened");
    $(".outlets__list-item-hiddenblock").slideDown();
    $(".icon-plus-css").addClass("opened");
    $(".outlets__list-item").show();
    $(".outlets__list-right").hide();
    $("button[item-to-filter] .item-to-filter-name").each(function() {
        let numberOfItems =
            $(this)
                .parents(".outlets__list-item")
                .attr("data-number-of-items") * 1;
        const text = $(this).text();
        if (!text.match(regExpVal)) {
            $(this)
                .parents("li")
                .hide();
            $(this)
                .parents(".outlets__list-item")
                .attr("data-number-of-items", numberOfItems);
        } else {
            // $(this).parents("li").show();
            if (
                !$(this)
                    .parents("li")
                    .hasClass("hide--brands")
            ) {
                $(this)
                    .parents("li")
                    .show();
            }
            $(this)
                .parents(".outlets__list-item")
                .attr("data-number-of-items", numberOfItems);
        }
    });
    $(".outlets__list-item").each(function() {
        const numberOfVisibleElements = $(this).find(
            "li:not([style='display: none;'])"
        ).length;
        const numberOfAllElements = $(this).data("number-of-items");
        if (
            numberOfAllElements - numberOfVisibleElements ===
            numberOfAllElements
        ) {
            $(this).hide();
        }
    });
};

$(".outlets-search-input_js").on("keyup blur", function() {
    filter_address_list($(this));
    // const val = $(this).val();
    // const regExpVal = new RegExp(val, "i");
    // $(".open_hiddenblock").addClass("opened");
    // $(".outlets__list-item-hiddenblock").slideDown();
    // $(".icon-plus-css").addClass("opened");
    // $(".outlets__list-item").show();
    // $("button[item-to-filter] .item-to-filter-name").each(function () {
    //     let numberOfItems = $(this).parents(".outlets__list-item").attr("data-number-of-items") * 1;
    //     const text = $(this).text();
    //     if (!text.match(regExpVal)) {
    //         $(this).parents("li").hide();
    //         $(this).parents(".outlets__list-item").attr("data-number-of-items", numberOfItems);
    //     } else {
    //         $(this).parents("li").show();
    //         $(this).parents(".outlets__list-item").attr("data-number-of-items", numberOfItems);
    //     }
    // });
    // $(".outlets__list-item").each(function () {
    //     const numberOfVisibleElements = $(this).find("li:not([style='display: none;'])").length;
    //     const numberOfAllElements = $(this).data("number-of-items");
    //     if (numberOfAllElements - numberOfVisibleElements === numberOfAllElements) {
    //         $(this).hide();
    //     }
    // });
});

$(document).ready(function() {
    // $(".outlets__list-item-hiddenblock").each(function () {
    //     tinysort($(this).find("li"), {charOrder: UKR_ALPH});
    // });

    let filter_points_by_brand = function(array) {
        const filterByBrands = [],
            brandChoosenCollection = $("#js-select-brands").data("value");
        if (brandChoosenCollection.length) {
            for (i in array) {
                if (
                    brandChoosenCollection.some(function(brand) {
                        return array[i]["brand_name"].indexOf(brand) >= 0;
                    })
                ) {
                    filterByBrands.push(array[i]);
                }
            }
        } else {
            return array;
        }

        return filterByBrands;
    };

    let filter = function(array, term) {
        var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
        return $.grep(array, function(value) {
            return matcher.test(value.city_name + " " + value.address);
        });
    };

    $.widget("custom.mapcomplete", $.ui.autocomplete, {
        _create: function() {
            this._super();
        },
        _renderItem: function(ul, item) {
            let label = item.city_name + " " + item.address;
            var li = $("<li>"),
                wrapper = $("<div>", {
                    title: label
                }).text(label);

            if (item.disabled) {
                this._addClass(li, null, "ui-state-disabled");
            }

            return li.append(wrapper).appendTo(ul);
        }
    });

    $("#autocomplete").mapcomplete({
        source: function(request, response) {
            return response(
                filter(filter_points_by_brand(window.points), request.term)
            );
        },
        position: {
            my: "left top+10"
        },
        select: function(event, ui) {
            event.preventDefault();
            $("#autocomplete").val(ui.item.city_name + ", " + ui.item.address);
            zoom_to_marker(
                ui.item.id,
                true,
                filter_points_by_brand(window.points)
            );
        },
        focus: function(event, ui) {
            event.preventDefault();

            allMarkers = allDefaultMarker.slice(0);
            setMapOnAll(myMap);
            markerCluster.addMarkers(allMarkers);

            $("#autocomplete").val(ui.item.city_name + ", " + ui.item.address);
            zoom_to_marker(
                ui.item.id,
                true,
                filter_points_by_brand(window.points)
            );
        },
        open: function() {
            tinysort(".ui-autocomplete li", { charOrder: UKR_ALPH });
        }
    });
    jQuery.ui.autocomplete.prototype._resizeMenu = function() {
        var ul = this.menu.element;
        ul.outerWidth(this.element.outerWidth());
    };
});
